import { makeApi } from "./callApi";
import { getLocation } from "../utils/helper";
export class CustomerProductApi {
  static async getCustomerProducts(data) {
    const response = await makeApi(`/customer-product/filter`, "POST", data);
    return response.data;
  }

  static async getCustomerProductById(id) {
    const response = await makeApi(`/customer-product/${id}`, "GET");
    return response.data;
  }

  static async createCustomerProduct(data) {
    const response = await makeApi(`/customer-product`, "POST", {
      locationDetails: getLocation(),
      ...data,
    });
    return response.data;
  }
}
